// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const azurill: PokeData = {
  "id": 298,
  "name": "azurill",
  "height": 2,
  "weight": 20,
  "base_experience": 38,
  "types": [
    PokeType.NORMAL,
    PokeType.FAIRY
  ],
  "api_moves": [
    "slam",
    "tail-whip",
    "water-gun",
    "bubble-beam",
    "bubble",
    "splash",
    "charm",
    "helping-hand",
    "bounce",
    "water-sport"
  ],
  "moves": [
    "bubble-beam",
    "bubble",
    "splash",
    "moonblast",
    "spirit-break",
    "tri-attack",
    "moonlight",
    "sweet-kiss",
    "misty-terrain",
    "starfall",
    "leer",
    "heal-bell",
    "refresh"
  ],
  "evolution_chain": {
    "id": 90,
    "item": {
      "name": "sea-incense"
    },
    "species": [
      {
        "name": "azurill",
        "order": 211,
        "types": [
          PokeType.NORMAL,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "marill",
        "order": 212,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 298,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": 160,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "azumarill",
        "order": 213,
        "types": [
          PokeType.WATER,
          PokeType.FAIRY
        ],
        "evolves_from_species_id": 183,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 18,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 45,
    "speed": 20,
    "ability_power": 20
  },
  "stat_changes": [],
  "catch_rate": 150,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
